import * as Actions from './ReportsActions';

const initialState = {
  reportFetchStatus: null,
  url: null,
  error: null,
  isGenerateReportOpen: false,
  sendReportByEmail: false
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GENERATE_REPORT_STARTED:
    case Actions.GENERATE_REPORT_SUBMITTED:
    case Actions.GENERATE_REPORT_RESUMED:
      return {
        ...state,
        reportFetchStatus: Actions.ReportStatus.FETCHING,
        sendReportByEmail: action && action.payload && action.payload.sendEmail ? action.payload.sendEmail : false
      };

    case Actions.GENERATE_REPORT_COMPLETED:
      return {
        ...state,
        reportFetchStatus: Actions.ReportStatus.COMPLETED,
        url: action.payload.url
      };
    case Actions.GENERATE_REPORT_FAILED:
      return {
        ...state,
        reportFetchStatus: Actions.ReportStatus.FAILED,
        error: action.error,
        sendReportByEmail: false
      };
    case Actions.GENERATE_REPORT_DELAYED:
      return {
        ...state,
        reportFetchStatus: Actions.ReportStatus.DELAYED
      };
    case Actions.GENERATE_REPORT_PAUSED:
      return {
        ...state,
        reportFetchStatus: Actions.ReportStatus.PAUSED
      };
    case Actions.GENERATE_REPORT_CANCELLED:
      return {
        ...state
      };
    case Actions.GENERATE_REPORT_MODAL_TOGGLE:
      return {
        ...state,
        isGenerateReportOpen: !state.isGenerateReportOpen
      };
    case Actions.GENERATE_EMAIL_REPORT:
      return {
        ...state,
        sendReportByEmail: false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Reducks/Reports/ReportsReducer.js